export default __webpack_public_path__ + "37ec2a7.png";